// /m — モバイル版 索引ページ (2026-07-22 現行タブ構成に更新)
// PC の正式9タブに連動。モバイルで見やすいものを移植、詳細分析系は PC 版へ誘導。
//   実装: 入院実績 / 行為別売上 / 手術売上 / 手術件数 / 入院経路 / PL
//   PC 版のみ: DPC分析 / 粗利分析 / 相関分析 (モバイル不向き = 索引に案内のみ)
import { Link } from "react-router-dom";
import { gpText } from "../lib/gpMode";

type Page = { path: string; name: string; emoji: string; desc?: string };

// モバイル実装済みページ (PC 正式タブ順)
const PAGES: Page[] = [
  { path: "/m/a-exec",    name: "入院実績",   emoji: "📈", desc: "病院全体KPI + 全科 予算比/前年比" },
  { path: "/m/a-kbrev",   name: "行為別売上", emoji: "💴", desc: "入院収入/入院料/手術/処置 の当月・前年比" },
  { path: "/m/a-opesr",   name: "手術売上",   emoji: "💴", desc: "科別手術収入 + 手術別(術式)上位" },
  { path: "/m/a-surgery", name: "手術件数",   emoji: "🔪", desc: "件数の月次推移 / 予算比 / 科別TOP" },
  { path: "/m/a-route",   name: "入院経路",   emoji: "🚪", desc: "新規入院の紹介/予定緊急/経由" },
  { path: "/m/a-pl",      name: "経営PL",     emoji: "💰", desc: "医業収益/経常利益/材料費 の月次・年計" },
];

// PC 版のみ (モバイル不向き = リンク先で PC 版を開く案内)
const PC_ONLY: { name: string; emoji: string; desc: string }[] = [
  { name: "DPC分析",  emoji: "🔬", desc: "DPC階層別ランキング + 14桁包括点数" },
  { name: gpText("粗利分析"), emoji: "💹", desc: gpText("科別/DPC別の粗利・1日粗利単価") },
  { name: "相関分析",  emoji: "🔗", desc: "入院実績指標の月次相関 散布図行列" },
];

export function MobileIndex() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-4 py-3">
        <div className="text-[10px] text-slate-400">病院実績ダッシュボード</div>
        <h1 className="text-base font-semibold text-slate-800">📱 モバイル版</h1>
        <p className="text-xs text-slate-500 mt-1">
          PC 版は <Link to="/?pc=1" className="text-blue-600 underline">こちら</Link>。
        </p>
      </header>

      <main className="px-3 py-3 space-y-2">
        {PAGES.map((p) => (
          <Link
            key={p.path}
            to={p.path}
            className="block bg-white border border-slate-200 rounded-lg px-4 py-3 hover:bg-slate-50 active:bg-slate-100"
          >
            <div className="flex items-center gap-3">
              <div className="text-xl shrink-0">{p.emoji}</div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-800">{p.name}</div>
                {p.desc && <div className="text-[11px] text-slate-400 truncate">{p.desc}</div>}
              </div>
              <div className="text-slate-300 text-lg shrink-0">›</div>
            </div>
          </Link>
        ))}

        {/* PC 版のみのタブ (モバイル不向き) */}
        <div className="pt-3">
          <div className="text-[11px] text-slate-400 px-1 mb-1">詳細分析は PC 版で</div>
          <Link
            to="/?pc=1"
            className="block bg-slate-100 border border-slate-200 rounded-lg px-4 py-3 hover:bg-slate-200/60 active:bg-slate-200"
          >
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {PC_ONLY.map((p) => (
                <div key={p.name} className="flex items-center gap-1.5 text-xs text-slate-600">
                  <span>{p.emoji}</span>
                  <span className="font-medium">{p.name}</span>
                </div>
              ))}
            </div>
            <div className="text-[10px] text-slate-400 mt-1.5">
              {gpText("DPC/粗利/相関は情報量が多くモバイル非対応。タップで PC 版を開きます。")}
            </div>
          </Link>
        </div>
      </main>

      <footer className="text-[10px] text-slate-400 text-center py-4">
        病院実績ダッシュボード ・ モバイル版
      </footer>
    </div>
  );
}
